<div class="selector-dialog"
     [class.open]="displayDialog"
     [class.disabled]="disabled"
     [class.invalid]="formModel.invalid && (formModel.dirty || formModel.formDirective?.submitted)">
  <div *ngIf="!hideLabel">
    <si-label [text]="text"
              [tooltipText]="tooltipText"
              [tooltipPosition]="tooltipPosition"
              [tooltipIcon]="tooltipIcon"
              [tooltipStyleClass]="tooltipStyleClass"
              [tooltipEscape]="tooltipEscape"
              [forceShowTooltipIcon]="forceShowTooltipIcon"
              (tooltipIconClick)="onClickTooltipIcon($event)"
    ></si-label>
  </div>
  <div class="selector-dialog_selector" (click)="onClickShowDialog()">
    <div class="d-flex">
      <div class="flex-grow-1 overflow-hidden">
        <div *ngIf="!model" class="selector-dialog_selector_model--placeholder">{{disabled ? '' : (placeholder | translate)}}</div>
        <ng-container *ngIf="type === 'date'; else defaultModel">
          <div class="selector-dialog_selector_model">{{model | amDateFormat: 'L'}}</div>
        </ng-container>
        <ng-template #defaultModel>
          <div class="selector-dialog_selector_model">{{model?.name || model}}</div>
        </ng-template>
      </div>
      <div *ngIf="showClear"
           class="selector-dialog_selector_icon--close"
           [hidden]="!model"
           (click)="onClickClearIcon($event)"></div>
      <div siProvideParentForm>
        <input #formModel="ngModel"
               id="hiddenInputSelectorDialog"
               name="hiddenInputSelectorDialog"
               type="hidden"
               [disabled]="disabled"
               [ngModel]="model"
               siValidation="{{rule}}" [siValidationElement]="validationElement"/>
        <si-validation-element #validationElement
                               [formModel]="formModel"
                               class="selector-dialog_selector_validation"
        ></si-validation-element>
      </div>
      <div class="selector-dialog_selector_icon--arrow" [class.open]="displayDialog"></div>
    </div>
  </div>
</div>
<ng-content></ng-content>
